import type { FC } from 'react';

import { Grid } from '@packages/shared';
import { useConfig } from '@packages/utilities';
import { useTheme } from '@mui/material';

import { ZeroResultsNoticeMessage } from '../ZeroResultsNoticeMessage';
import type { TopCategoriesProps } from '../TopCategories';
import { TopCategories } from '../TopCategories';
import { NeedHelpSection } from '../NeedHelpSection';
import { SearchTipsSection } from '../SearchTipsSection';
import { SearchFeedback } from '../SearchFeedback';

export type SearchResultPageZeroResultsProps = Partial<TopCategoriesProps>;

/**
 * Search result page if no results are available
 * Reasons for that could be:
 * - search query was on blacklist
 * - no normal results, and QueryReduction and DeepQuery both failed
 * */
export const SearchResultPageZeroResults: FC<SearchResultPageZeroResultsProps> = ({
  topCategories = [],
}) => {
  const { breakpoints } = useTheme();

  const { feedback } = useConfig();

  return (
    <Grid container item spacing={1} gap={1} direction="column">
      <Grid item>
        <ZeroResultsNoticeMessage />
      </Grid>
      <Grid item>
        <SearchTipsSection />
      </Grid>
      <Grid
        item
        sx={{
          bgcolor: 'grey.light',
          marginTop: 1,
          marginLeft: 1,
          [breakpoints.down('xl')]: {
            marginLeft: -2,
            marginRight: -3,
          },
          [breakpoints.down('lg')]: {
            marginLeft: -1,
            marginRight: -2,
          },
          '&.MuiGrid-item': {
            padding: 2,
          },
        }}
      >
        <TopCategories topCategories={topCategories} />
      </Grid>
      {feedback.enabled && (
        <Grid item>
          <SearchFeedback />
        </Grid>
      )}
      <Grid item>
        <NeedHelpSection />
      </Grid>
    </Grid>
  );
};
